import React, { useState } from "react";
import "./Terms.css";

const Terms = () => {
  const [activeSection, setActiveSection] = useState(null);

  const toggleSection = (index) => {
    setActiveSection(activeSection === index ? null : index);
  };

  const terms = [
    {
      heading: "Introduction",
      content: `This is a legal and binding agreement between you, the user (referred to as "user" or "you") of the Programs, and upGrad (together with its subsidiaries and international affiliates, hereinafter "upGrad," "us," "we," or "our" or "the Company") stating the terms that govern your use of the Platform.`,
    },
    {
      heading: "Acceptance of Terms",
      content: `By accepting these Terms in any manner or accessing the website, you consent, agree, and undertake to abide, be bound by, and adhere to the Terms. If you do not agree to these Terms, you are not entitled to avail of/use the Programs, and any use thereafter shall be unauthorized.`,
    },
    {
      heading: "Changes to Terms",
      content: `We may change these Terms from time to time without prior notice. You should review this page regularly. Your continued use of the Platform and Programs after changes have been made will be taken to indicate that you have read and accepted those changes.`,
    },
  ];

  const [isExpanded, setIsExpanded] = useState(false);

  const toggleReadMore = () => {
    setIsExpanded(!isExpanded);
  };


  const content = `
    1. The above statistics depend on various factors and individual results may vary. Past performance is no guarantee of future results.
    2. The student assumes full responsibility for all expenses associated with visas, travel, and related costs. upGrad does not provide any assurance or make representations regarding visa approval or the procurement of the visa.
    3. upGrad does not grant credit; credits are granted, accepted, or transferred at the sole discretion of an educational institution. upGrad does not make any representations regarding the recognition or equivalence of the credits or credentials awarded, unless otherwise expressly stated. If you intend to pursue a post-graduate or doctorate degree upon completion of this course or apply for employment which requires specific credits, we advise you to inquire further regarding the suitability of this degree for your academic and/or professional requirements before enrolling.
    4. Finance, No Cost EMI and Credit Card EMI options, are provided by third-party financial institutions. Terms and conditions are subject to change at their discretion without prior notice. Please verify details with the respective service provider before proceeding.
    5. The estimates provided on savings are indicative and may vary based on the program, scholarships, and promotions available. Actual savings will depend on individual circumstances.
    6. The savings figure is indicative and based on specific assumptions. Actual savings may vary depending on individual circumstances.
    7. Cost-of-living estimates are indicative only and subject to variation based on personal lifestyle choices, location, exchange rates, and other factors. Actual expenses may differ from the stated figures.
  `;

  // Convert the content string into an array of points
  const contentPoints = content.trim().split("\n").map((point, index) => (
    <p key={index}>{point}</p>
  ));

  return (
    <div className="terms-container-body">
      <p className="termss-textt">Terms and Conditions</p>
      <div className="terms-container">
        {terms.map((term, index) => (
          <div key={index} className="term-section">
            <div className="term-header">
              <h2 className="introduction-text">{term.heading}</h2>
              <button className="toggle-button" onClick={() => toggleSection(index)}>
                {activeSection === index ? "-" : "+"}
              </button>
            </div>
            {activeSection === index && (
              <div>
                <p className="terms-sub-text">{term.content}</p>
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="disclaimer-container">
        <h2 className="disclaimer-container-text">Disclaimer</h2>
        <div className={isExpanded ? "term-p expanded" : "term-p collapsed"}>
          {contentPoints.slice(0, 2)} {/* Show only the first two points initially */}
          {isExpanded && contentPoints.slice(2)} {/* Show remaining content when expanded */}
        </div>
        <button className="read-more-button" onClick={toggleReadMore}>
          {isExpanded ? "Read Less" : "Read More..."}
        </button>
      </div>
    </div>
  );
};

export default Terms;
